module.exports = __webpack_public_path__ + "img/sv31on.68737c4b.svg";